module.exports = "/images/claim_patient.jpg?7b5a096ad301fda91ed53549bc197418";